import React from 'react';
import * as styles from './styles/styles.module.scss';
import PropTypes from 'prop-types';

const CloudCheckbox = props => {
  return (
    <div className={styles.container}>
      <input className={styles.checkbox} value={props.value} onChange={props.onChange} id={props.value} type="checkbox" checked={props.checked} />
      <label htmlFor={props.value}>{props.label}</label>
    </div>
  );
};

CloudCheckbox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};

export default CloudCheckbox;
